/** Catalog entries as checklist items: roles carry their studios as subtitle. */
export const roleItems = (roles) =>
  roles.map(({ id, name, studios }) => ({ id, name, subtitle: (studios ?? []).join(' · ') }));
export const groupItems = (groups) => groups.map(({ id, name }) => ({ id, name }));

/** Adds `id` to `ids`, or removes it when already there. */
export const toggleId = (ids, id) => (ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
